export const inputAreaCn = 'rounded-md py-2 focus:ring-magic focus:border-magic border-none'
export const wrapperInputCn = 'flex flex-col space-y-2 w-full px-4 py-2 bg-[#F9F8F8] rounded-lg'
export const labelCn = 'text-sm sm:text-base'
export const recreateOutlineBtns = 'text-sm bg-magic-light text-deepgray'